import * as React from "react";
import { Builder } from "@builder.io/react";

export const ImgURL = (props) => (
    <div style={{width: "80%", display: "flex", justifyContent: "center", margin: "auto"}}>
        <figure>
            <img style={{width: "100%"}} src={props.URL} alt={props["Alt text"]} />
            <figcaption style={{color: "rgba(117, 117, 117, 1)", fontSize: "14px", textAlign: "center"}}>{props.Caption}</figcaption>
        </figure>
    </div>
);

Builder.registerComponent(ImgURL, {
  name: "Blog Img",
  inputs: [
    {
      name: "URL",
      type: "string",
      defaultValue: "",
    },
    {
        name: "Alt text",
        type: "string",
        defaultValue: "",
    },
    {
        name: "Caption",
        type: "string",
        defaultValue: "",
    }
  ],
});